
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.factory('restClientServices', restClientServices);

	/**
	 * Generic services for invoke differents Rest services type.
	 *
	 * @param {any} $resource
	 * @returns
	 */
	function restClientServices($auth, $resource, $rootScope, $state, sessionFactory, utilitiesConstant) {
		'ngInject';

		let service = {
			deleteService: deleteService,
			downloadService: downloadService,
			ganaService: ganaService,
			getService: getService,
			postService: postService,
			putService: putService,
			queryService: queryService
		};

		return service;

		/**
		 * Generic function for invoke Rest service of delete type.
		 *
		 * @param {*} url
		 * @param {*} paramsUrl
		 */
		function deleteService(url, paramsUrl = {}) {
			const resource = $resource(url);
			return resource.delete(paramsUrl).$promise;
		}

		/**
		 * Generic function for invoke Rest service of get type to download file from server.
		 *
		 * @param {*} url
		 * @param {*} paramsUrl
		 */
		function downloadService(url, paramsUrl = {}) {
			const resource = $resource(url, paramsUrl, {
				getFile: {
					method: 'GET',
					responseType: 'arraybuffer',
					cache: false,
					transformResponse: function (data) {
						const content = new Blob([data], {
							type: 'application/octet-stream'
						});
						return {
							file: content
						};
					}
				},
			});
			return resource.getFile(paramsUrl).$promise;
		}

		/**
		 * Generic function for invoke Rest service of get type, but only to send the gana rest services .
		 *
		 * @param {any} url
		 * @param {any} [paramsUrl={}]
		 * @returns
		 */
		function ganaService(url, paramsUrl = {}) {
			const resource = $resource(url, paramsUrl, {
				getData: {
					method: 'GET',
					transformResponse: function (data, headers, httpStatus) {
						const response = angular.fromJson(data);
						/**
						 * If the token exist in the data object,
						 * then the  saved token in web storage will be update.
						 */
						if (httpStatus === 200 && response && response.token) {
							//Set auth token with the response token.
							$auth.setToken(response.token);
						} else if (httpStatus === 423) {
							sessionFactory.remove(utilitiesConstant.STORAGE.AUTHENTICATED);
							sessionFactory.remove(utilitiesConstant.STORAGE.USER);

							$auth.logout();

							$rootScope.userAuth = null;
							$rootScope.menuItems = null;
							$rootScope.submenus = null;
							$rootScope.tokenExpired = utilitiesConstant.MSG_TOKEN_EXPIRED;

							$state.go('authentication');
						}
						return response.data;
					}
				},
			});
			return resource.getData(paramsUrl).$promise;
		}

		/**
		 * Generic function for invoke Rest service of get type.
		 *
		 * @param {*} url
		 * @param {*} paramsUrl
		 */
		function getService(url, paramsUrl = {}) {
			const resource = $resource(url);
			return resource.get(paramsUrl).$promise;
		}

		/**
		 * Generic function for invoke Rest service of post type.
		 *
		 * @param {*} url
		 * @param {*} paramDefaults
		 * @param {*} isArray
		 * @param {*} objectRequest
		 */
		function postService(url, paramDefaults = {}, isArray = false, objectRequest) {
			const resource = $resource(url, paramDefaults, {
				saveData: {
					method: 'POST',
					isArray: isArray,
					interceptor: {
						response: response => response
					}
				}
			});
			return resource.saveData(objectRequest).$promise;
		}

		/**
		 * Generic function for invoke Rest service of put type.
		 *
		 * @param {any} url
		 * @param {any} [paramDefaults={}]
		 * @param {boolean} [isArray=false]
		 * @param {any} [paramsUrl={}]
		 * @param {any} objectRequest
		 * @returns
		 */
		function putService(url, paramDefaults = {}, isArray = false, paramsUrl = {}, objectRequest) {
			const resource = $resource(url, paramDefaults, {
				update: {
					method: 'PUT',
					isArray: isArray,
					interceptor: {
						response: response => response
					}
				}
			});
			return resource.update(paramsUrl, objectRequest).$promise;
		}

		/**
		 * Generic function for invoke Rest service of query (GET) type.
		 *
		 * @param {any} url
		 * @param {any} [paramsUrl={}]
		 * @returns
		 */
		function queryService(url, paramsUrl = {}) {
			const resource = $resource(url);
			return resource.query(paramsUrl).$promise;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/core/services/restClient.factory.js